import { Component, Input, ElementRef, ViewChild, OnInit, Output, EventEmitter } from '@angular/core';
import { InlineFieldInterfaceComponent } from '../inline-field-interface.component';
import { PartialFormField } from '../../form-fields/form-field.types';

@Component({
  selector: 'textarea-inline-field',
  templateUrl: './textarea-inline-field.component.html',
  styleUrls: ['./textarea-inline-field.component.scss'],
})
export class TextAreaInlineFieldComponent implements InlineFieldInterfaceComponent, OnInit {
  @ViewChild('inputControl') inputControl: ElementRef;

  @Input() model: any;
  @Input() fieldDef: any;
  @Input() data: any;
  @Input() excludeLabels: boolean = false;
  @Input() readonly: boolean = false;
  @Input() canClick: boolean = false;
  @Output() onClick: EventEmitter<PartialFormField> = new EventEmitter();
  @Output() update: EventEmitter<PartialFormField> = new EventEmitter();

  public editing: boolean = false;
  public value;
  public showTip: string;
  private _originalValue;
  private _readonly;

  ngOnInit() {
    this.value = this.fieldDef.meta?.value_hidden ? 'REDACTED' : this.model[this.fieldDef.name];

    // we want to track the original value, so that we don't hit save to many times
    this._originalValue = this.value;
    this.showTip = this.fieldDef.meta?.calc_code;
    if (this.fieldDef.meta && this.fieldDef.meta.readonly) {
      this._readonly = this.fieldDef.meta.readonly;
    }
    if (this.readonly) {
      this._readonly = this.readonly;
    }
    this.readonly = this._readonly;
  }

  edit() {
    if (!this.editing && !this._readonly) {
      this.editing = true;
      setTimeout(() => {
        this.inputControl.nativeElement.focus();
      }, 300);
    }
  }

  onBlur($event: Event) {
    this.onSave();
    this.editing = false;
  }

  /**
   * When the model is updated after save, re-run our logic
   * @param model
   */
  updateChangedModel(model: any): void {
    this.model = model;
    //this.value = this.model[this.fieldDef.name] * 100;
    this.value = this.model[this.fieldDef.name];

    // we want to track the original value, so that we don't hit save to many times
    this._originalValue = this.value;
  }

  onSave() {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  updateModel() {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }

  clickField($event) {
    this.onClick.emit($event);
  }
}
